import React from "react";
import PropTypes from "prop-types";

/**
 * Soft, non-blocking segregation-of-duties (SoD) warning shown near the role
 * selector on the user-assignment pages. Purely informational — rendering
 * this never disables Save/Create.
 */
export default function RoleConflictWarning({ conflicts }) {
  if (!conflicts || conflicts.length === 0) return null;

  return (
    <div className="mt-3 px-4 py-3 bg-warning-soft border border-warning rounded-card text-sm text-text" role="status">
      {conflicts.map((pair, i) => (
        <div key={`${pair.a}|${pair.b}`} className={i > 0 ? "mt-1" : ""}>
          <span className="font-medium">{pair.a}</span> and <span className="font-medium">{pair.b}</span> are
          typically kept separate (segregation of duties).
        </div>
      ))}
    </div>
  );
}

RoleConflictWarning.propTypes = {
  conflicts: PropTypes.arrayOf(
    PropTypes.shape({ a: PropTypes.string.isRequired, b: PropTypes.string.isRequired })
  ),
};
